module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS5.b53bb48f.jpg";